import { FormGroup } from '@material-ui/core'
import React from 'react'

export const IUIFormGroup = (props) => {
  return <FormGroup>{props.children}</FormGroup>
}
